import React from 'react';
import styled from 'styled-components';
import { IonButton, IonIcon } from '@ionic/react';

export const Btn = styled(IonButton)`
  --padding-start: 0;
  --padding-end: 0;
`;

export const Menu = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-left: 25px;
`;

export const Button: React.FC<{
  icon: any;
  onClick?: () => void;
  disabled?: boolean;
}> = ({ icon, onClick, disabled }) => {
  return (
    <Btn
      fill='clear'
      onClick={e => {
        e.preventDefault();
        if (onClick) {
          onClick();
        }
      }}
      disabled={typeof disabled === 'undefined' ? false : disabled}
    >
      <IonIcon slot='icon-only' icon={icon} />
    </Btn>
  );
};
